import * as React from 'react';

import Button from 'components/Button';
import LinkConstants from 'constants/LinkConstants';
// @ts-ignore
import userAgent from 'lib/currentUserAgent';
import { hardRedirectTo } from 'lib/ClientRouteLogic';

type Props = {
  children: React.ReactNode;
};

export default class OpenAppOrAppStoreButton extends React.Component<Props> {
  componentDidMount() {
    if (!userAgent.mobile()) {
      console.warn(`Platform ${userAgent.clientSegment()}`);
      console.error(`OpenAppOrAppStoreButton rendered from unsupported platform`);
    }
  }

  openOnAndroid = () => {
    hardRedirectTo(LinkConstants.ANDROID_APP_OR_APP_STORE);
  };

  render() {
    if (userAgent.android()) {
      // This url (intent://) can't be a regular link since it will give a sameorigin policy error.
      return <Button onClick={this.openOnAndroid}>{this.props.children}</Button>;
    } else if (userAgent.ios()) {
      // on the other hand, iOS will fail if it's not href
      return <Button href={LinkConstants.IOS_APP_OR_APP_STORE}>{this.props.children}</Button>;
    } else {
      return null;
    }
  }
}
